import { render } from "./VerifyEmailView.vue?vue&type=template&id=38860c76"
import script from "./VerifyEmailView.vue?vue&type=script&lang=js"
export * from "./VerifyEmailView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/VerifyEmailView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38860c76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38860c76', __exports__)) {
    api.reload('38860c76', __exports__)
  }
  
  module.hot.accept("./VerifyEmailView.vue?vue&type=template&id=38860c76", () => {
    api.rerender('38860c76', render)
  })

}


export default __exports__